export default {
  mounted() {
    if (this.titular) {
      const email = sessionStorage.getItem("email");
      const celular = sessionStorage.getItem("celular");
      this.email = email === "null" ? null : email;
      this.celular = celular === "null" ? null : celular;
    } else {
      const dependentes = JSON.parse(sessionStorage.getItem("dependentes"));
      
      const email = dependentes[this.indiceDependente].email;
      const celular = dependentes[this.indiceDependente].celular;
      this.email = email === "null" ? null : email;
      this.celular = celular === "null" ? null : celular;
    }
    this.idPaciente = sessionStorage.getItem("idPaciente");
    this.token = sessionStorage.getItem("token");
  },
  data: () => ({
    email: "",
    celular: "",
    idPaciente: null,
    token: "",
  }),
  methods: {
    sendValidationCode(validationMethod, captcha) {
      return new Promise((resolve, reject) => {
        let url = "";
        const payload = {
          pacienteId: this.titular ? this.idPaciente : this.idDependente,
        };
        if (validationMethod === "email") {
          Object.assign(payload, { email: this.email });
          url = "/enviar_email";
        } else {
          Object.assign(payload, { telefone: this.celular });
          url = "/enviar_sms";
        }
        this.$conexaApi
          .post(`/confirmacao_dados_usuario${url}`, payload, {
            headers: { captcha },
          })
          .then(() => resolve())
          .catch(() => reject())
          .finally(() => {
            NProgress.done();
          });
      });
    },
  },
};
